// #region License

/**
 * @license
 * Copyright (C) JVS-Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import type { ThemeIcon } from './ApplicationThemeContextProvider';

export type ApplicationThemeVariant =
	| "auto"
	| "horizon"
	| "millesime"
	| "interco";

export type ApplicationThemeContextProps = {
	theme: ThemeIcon;
	setTheme: React.Dispatch<React.SetStateAction<ThemeIcon>>;

	/** */
	variant: ApplicationThemeVariant;

	/** */
	setVariant?: React.Dispatch<React.SetStateAction<ApplicationThemeVariant>>;
};

export const ApplicationThemeContext =
	React.createContext<ApplicationThemeContextProps>({
		setTheme: null,
		setVariant: null,
		theme: 'sun',
		variant: "auto",
	});
